import React from 'react';
import { TextField, Grid, Button } from '@mui/material';

export const ResendEmailForm = ({
  email,
  setEmail,
  handleSubmit,
  isResendingEmail,
}) => {
  return (
    <form onSubmit={handleSubmit} noValidate>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <TextField
            label="Email"
            type="email"
            variant="outlined"
            fullWidth
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={isResendingEmail}
          >
            Conferma
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};